<div class="p-2">
  <div class="pl-3">
    <div>
      <div class="matter-sb-header" (click)="optionsExpand.solr_reindex = !optionsExpand.solr_reindex">
        <h5 class="font-weight-normal">
          <a style="font-size: 14px; padding-bottom: 4px" href="javascript: void(0)"><i [class]="'fa fa-' + (optionsExpand.solr_reindex ? 'minus' : 'plus') + '-circle'"></i></a>&nbsp;&nbsp;Solr Reindex
        </h5>
      </div>
      <div class="matter-sb-content pl-2 pt-2" [hidden]="!optionsExpand.solr_reindex">
        <div class="row">
          <div class="col-12 py-2">
            <div class="d-flex flex-wrap gap-1">
              <button type="button" class="btn btn-outline-primary btn-sm mr-1 mb-1" [disabled]="reindexingSolr" (click)="reindexSolr('all')">All</button>
              <button type="button" class="btn btn-outline-primary btn-sm mr-1 mb-1" [disabled]="reindexingSolr" (click)="reindexSolr('documents')">Documents</button>
              <button type="button" class="btn btn-outline-primary btn-sm mr-1 mb-1" [disabled]="reindexingSolr" (click)="reindexSolr('involvements')">Involvements</button>
              <button type="button" class="btn btn-outline-primary btn-sm mr-1 mb-1" [disabled]="reindexingSolr" (click)="reindexSolr('histories')">Histories</button>
              <button *ngIf="isAdmin" type="button" class="btn btn-outline-secondary btn-sm mr-1 mb-1" [disabled]="reindexingDocumentsPlus" (click)="reindexDocumentsPlus()">
                Documents+
              </button>
            </div>
            <div *ngIf="reindexingSolr">Reindex being called <i class="fas fa-spinner fa-fw fa-pulse"></i></div>
            <div *ngIf="reindexingDocumentsPlus">Reindexing documents from files <i class="fas fa-spinner fa-fw fa-pulse"></i></div>
            <pre *ngIf="documentsReindexStatus" class="mt-2 small text-muted mb-0" style="white-space: pre-wrap; font-family: inherit;">{{ documentsReindexStatus }}</pre>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div class="matter-sb-header" (click)="optionsExpand.clone_matter = !optionsExpand.clone_matter">
        <h5 class="font-weight-normal">
          <a style="font-size: 14px; padding-bottom: 4px" href="javascript: void(0)"><i [class]="'fa fa-' + (optionsExpand.clone_matter ? 'minus' : 'plus') + '-circle'"></i></a>&nbsp;&nbsp;Clone Matter
        </h5>
      </div>
      <div class="matter-sb-content pl-2 pt-2" [hidden]="!optionsExpand.clone_matter">
        <div class="row pb-1">
          <div class="col-12">
            <h5>Clone Matter</h5>
          </div>
        </div>
        <div class="form-group form-row" *ngIf="userGroups.indexOf('priviledged') > -1">
          <label class="col-4 col-form-label">Intranets</label>
          <div class="col-8">
            <app-intranet-search [editable]="intranetEditable" [include_item]="true" (clearIntranet)="matterClone.intranet_id = undefined" (intranet)="onIntranetSelect($event)"></app-intranet-search>
            <span *ngIf="intranet">{{ intranet.name }}</span>
          </div>
        </div>
        <div class="form-group form-row">
          <label class="col-4 col-form-label">Parent Matter</label>
          <div class="col-8">
            <app-matter-search (clearMatter)="clearParentMatter()" (matter_id)="matterClone.parent_matter_id = $event"></app-matter-search>
          </div>
        </div>
        <div class="form-group form-row">
          <label class="col-4 col-form-label"></label>
          <div class="col-8">
            <div class="custom-control custom-checkbox" (click)="matterClone.is_private == '0' ? (matterClone.is_private = '1' && (isPrivateCheckbox.checked = true)) : (matterClone.is_private = '0' && (isPrivateCheckbox.checked = false))">
              <input name='is_private' ngDefaultControl type="checkbox" #isPrivateCheckbox name="is_private" class="custom-control-input" />
              <label class="custom-control-label">Is private</label>
            </div>
            <div class="custom-control custom-checkbox" (click)="matterClone.is_personnel == '0' ? (matterClone.is_personnel = '1' && (isPersonnelCheckbox.checked = true)) : (matterClone.is_personnel = '0' && (isPersonnelCheckbox.checked = false))">
              <input name='is_personnel' ngDefaultControl type="checkbox" #isPersonnelCheckbox name="is_personnel" class="custom-control-input" />
              <label class="custom-control-label">Personnel file</label>
            </div>
            <div class="custom-control custom-checkbox" (click)="matterClone.in_collections == '0' ? (matterClone.in_collections = '1' && (inCollectionsCheckbox.checked = true)) : (matterClone.in_collections = '0' && (inCollectionsCheckbox.checked = false))">
              <input name='in_collections' ngDefaultControl type="checkbox" #inCollectionsCheckbox name="in_collections" class="custom-control-input" />
              <label class="custom-control-label">In collections</label>
            </div>
          </div>
        </div>
        <div class="form-group form-row">
          <label class="col-4 col-form-label">Matter Type</label>
          <div class="col-8">
            <select name='matter_type_id' ngDefaultControl class="form-control" [(ngModel)]="matterClone.matter_type_id">
              <option *ngFor="let matterType of matterTypes" [value]="matterType.id">{{ matterType.label }}</option>
            </select>
          </div>
        </div>
        <div class="form-group form-row">
          <label class="col-4 col-form-label">Rate Type</label>
          <div class="col-8">
            <select name='rate_type_id' ngDefaultControl class="form-control" [(ngModel)]="matterClone.rate_type_id">
              <option *ngFor="let rateType of rateTypes" [value]="rateType.id">{{ rateType.label }}</option>
            </select>
          </div>
        </div>
        <div class="form-group form-row">
          <label class="col-4 col-form-label"></label>
          <div class="col-8">
            <div class="custom-control custom-checkbox" (click)="matterClone.involvements == '0' ? (matterClone.involvements = '1' && (involvementsCheckbox.checked = true)) : (matterClone.involvements = '0' && (involvementsCheckbox.checked = false))">
              <input name='involvements-checkbox' ngDefaultControl type="checkbox" #involvementsCheckbox name="involvements" class="custom-control-input" />
              <label class="custom-control-label">Involvements</label>
            </div>
            <div class="custom-control custom-checkbox" (click)="matterClone.matter_users == '0' ? (matterClone.matter_users = '1' && (matterUsersCheckbox.checked = true)) : (matterClone.matter_users = '0' && (matterUsersCheckbox.checked = false))">
              <input name='matter_users_checkbox' ngDefaultControl type="checkbox" #matterUsersCheckbox name="matter_users" class="custom-control-input" />
              <label class="custom-control-label">Matter users</label>
            </div>
            <div class="custom-control custom-checkbox" (click)="matterClone.matter_dates == '0' ? (matterClone.matter_dates = '1' && (matterDatesCheckbox.checked = true)) : (matterClone.matter_dates = '0' && (matterDatesCheckbox.checked = false))">
              <input name='matter_dates_checkbox' ngDefaultControl type="checkbox" #matterDatesCheckbox name="matter_dates" class="custom-control-input" />
              <label class="custom-control-label">Matter dates</label>
            </div>
            <div class="custom-control custom-checkbox" (click)="matterClone.details == '0' ? (matterClone.details = '1' && (detailsCheckbox.checked = true)) : (matterClone.details = '0' && (detailsCheckbox.checked = false))">
              <input name='details_checkbox' ngDefaultControl type="checkbox" #detailsCheckbox name="details" class="custom-control-input" />
              <label class="custom-control-label">Details</label>
            </div>
            <div class="custom-control custom-checkbox" (click)="matterClone.documents == '0' ? (matterClone.documents = '1' && (documentsCheckbox.checked = true)) : (matterClone.documents = '0' && (documentsCheckbox.checked = false))">
              <input name='documents_checkbox' ngDefaultControl type="checkbox" #documentsCheckbox name="documents" class="custom-control-input" />
              <label class="custom-control-label">Documents</label>
            </div>
            <div class="custom-control custom-checkbox" (click)="matterClone.matter_histories == '0' ? (matterClone.matter_histories = '1' && (matterHistoriesCheckbox.checked = true)) : (matterClone.matter_histories = '0' && (matterHistoriesCheckbox.checked = false))">
              <input name='matter_histories_checkbox' ngDefaultControl type="checkbox" #matterHistoriesCheckbox name="matter_histories" class="custom-control-input" />
              <label class="custom-control-label">Matter histories</label>
            </div>
            <div class="custom-control custom-checkbox" (click)="matterClone.tags == '0' ? (matterClone.tags = '1' && (tagsCheckbox.checked = true)) : (matterClone.tags = '0' && (tagsCheckbox.checked = false))">
              <input name='tags_checkbox' ngDefaultControl type="checkbox" #tagsCheckbox name="tags" class="custom-control-input" />
              <label class="custom-control-label">Tags</label>
            </div>
          </div>
        </div>
        <div class="form-group form-row pb-3">
          <div class="col-12 text-center">
            <button type="button" class="btn btn-primary" (click)="clone()" [disabled]="cloning">
              {{ cloning ? 'Cloning' : 'Clone' }}<span *ngIf="cloning">&nbsp;<i class="fas fa-spinner fa-fw fa-pulse"></i></span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div class="matter-sb-header" (click)="optionsExpand.archive = !optionsExpand.archive">
        <h5 class="font-weight-normal">
          <a style="font-size: 14px; padding-bottom: 4px" href="javascript: void(0)"><i [class]="'fa fa-' + (optionsExpand.archive ? 'minus' : 'plus') + '-circle'"></i></a>&nbsp;&nbsp;Archive/Restore
        </h5>
      </div>
      <div class="matter-sb-content pl-2 pt-2" [hidden]="!optionsExpand.archive">
        <div class="row pb-1">
          <div class="col-12">
            <h5>{{ isArchived ? 'Restore' : 'Archive' }} Matter</h5>
            <div class="alert alert-info my-1" *ngIf="archiveStatus">{{ archiveStatus }}</div>
          </div>
        </div>
        <div class="row pb-2">
          <div class="col-12">
            <button type="button" class="btn btn-primary" [disabled]="archiving" (click)="archive()">
              {{ isArchived ? (archiving ? 'Restoring' : 'Restore') : archiving ? 'Archiving' : 'Archive' }} Matter<span *ngIf="archiving">&nbsp;<i class="fas fa-spinner fa-fw fa-pulse"></i></span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div class="matter-sb-header" (click)="optionsExpand.partial_archive = !optionsExpand.partial_archive">
        <h5 class="font-weight-normal">
          <a style="font-size: 14px; padding-bottom: 4px" href="javascript: void(0)"><i [class]="'fa fa-' + (optionsExpand.partial_archive ? 'minus' : 'plus') + '-circle'"></i></a>&nbsp;&nbsp;Partial Archive/Restore
        </h5>
      </div>
      <div class="matter-sb-content pl-2 pt-2" [hidden]="!optionsExpand.partial_archive">
        <div class="form-group form-row mb-0 mt-3">
          <label class="col-2 col-form-label-sm">Archive</label>
          <div class="col-5" *ngFor="let model of matterArchiveOptions.archiveModels">
            <div class="custom-control custom-checkbox" (click)="archiveModelCheckbox.checked = !archiveModelCheckbox.checked; typeChange(archiveModelCheckbox.checked, model.value)">
              <input name='archive_model_checkbox' ngDefaultControl type="checkbox" #archiveModelCheckbox [name]="'archive-model-' + model.value" class="custom-control-input" />
              <label class="custom-control-label">{{ model.label }}</label>
            </div>
          </div>
        </div>
        <div class="form-group form-row">
          <label class="col-2 col-form-label-sm text-right">before</label>
          <div class="col-5">
            <select name='matter_archive_params_before' ngDefaultControl class="form-control form-control-sm" [(ngModel)]="matterArchiveParams.before">
              <option *ngFor="let duration_ago of matterArchiveOptions.after" [value]="duration_ago.value">
                {{ duration_ago.label }}
              </option>
            </select>
          </div>
          <div class="col-1">
            <button type="button" class="btn btn-primary btn-sm" (click)="archive(true)" [disabled]="archiving || matterArchiveParams.types.length < 1">
              <span *ngIf="!archiving">Go</span>
              <span *ngIf="archiving">&nbsp;<i class="fas fa-spinner fa-fw fa-pulse"></i></span>
            </button>
          </div>
        </div>
        <hr />
        <div class="form-group form-row">
          <div class="col">
            <button type="button" [disabled]="archiving || matterArchiveParams.types.length < 1" (click)="restoreArchived()" class="btn btn-sm btn-primary btn-block">Restore archived</button>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div class="matter-sb-header" (click)="optionsExpand.conflict_check = !optionsExpand.conflict_check">
        <h5 class="font-weight-normal">
          <a style="font-size: 14px; padding-bottom: 4px" href="javascript: void(0)"><i [class]="'fa fa-' + (optionsExpand.conflict_check ? 'minus' : 'plus') + '-circle'"></i></a>&nbsp;&nbsp;Conflict Check
        </h5>
      </div>
      <div class="matter-sb-content pl-2 pt-2" [hidden]="!optionsExpand.conflict_check">
        <div class="row pb-1">
          <div class="col-12">
            <p class="small text-muted mb-2">Check for conflicts of interest based on contacts in this matter.</p>
          </div>
        </div>
        <div class="row pb-2">
          <div class="col-12">
            <button type="button" class="btn btn-primary btn-sm" [disabled]="checkingConflicts" (click)="checkConflicts()">
              {{ checkingConflicts ? 'Checking' : 'Check Conflicts' }}<span *ngIf="checkingConflicts">&nbsp;<i class="fas fa-spinner fa-fw fa-pulse"></i></span>
            </button>
          </div>
        </div>
        <div *ngIf="conflictResults" class="row">
          <div class="col-12">
            <div *ngIf="conflictResults.conflicts?.length === 0" class="alert alert-success py-1 small">
              <i class="fa fa-check-circle"></i> No conflicts found
            </div>
            <div *ngIf="conflictResults.conflicts?.length > 0 && !conflictResults.approved" class="alert alert-warning py-1 small mb-2">
              <i class="fa fa-exclamation-triangle"></i> Found {{ conflictResults.conflicts.length }} potential conflict(s) - <strong>Approval Required</strong>
            </div>
            <div *ngIf="conflictResults.conflicts?.length > 0 && conflictResults.approved" class="alert alert-success py-1 small mb-2">
              <i class="fa fa-check-circle"></i> {{ conflictResults.conflicts.length }} conflict(s) approved by {{ conflictResults.approved_by_name }} on {{ conflictResults.approved_at }}
            </div>
            <!-- Grouped by Role Type -->
            <div *ngIf="conflictsByRole.length > 0">
              <div *ngFor="let roleGroup of conflictsByRole" class="mb-1">
                <div class="bg-light p-2 border" style="cursor: pointer;" (click)="toggleRoleExpand(roleGroup.role)">
                  <div class="d-flex justify-content-between align-items-center">
                    <span>
                      <i [class]="'fa fa-' + (roleExpanded[roleGroup.role] ? 'minus' : 'plus') + '-circle mr-1'"></i>
                      <i class="fa fa-gavel mr-1"></i> {{ roleGroup.role }}
                    </span>
                    <span class="badge badge-warning">{{ roleGroup.conflicts.length }}</span>
                  </div>
                </div>
                <div [hidden]="!roleExpanded[roleGroup.role]" class="border border-top-0 p-2 small">
                  <div *ngFor="let conflict of roleGroup.conflicts" class="py-1 border-bottom">
                    <a [routerLink]="['/matters', conflict.matter_id]" target="_blank">
                      <strong>{{ conflict.matter_number }}</strong>: {{ conflict.matter_name }}
                    </a>
                    <span *ngIf="conflict.archived" class="badge badge-secondary ml-1">Archived</span>
                    <div class="text-muted" style="font-size: 11px;">
                      <i class="fa fa-user mr-1"></i>{{ conflict.contact_name }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="conflictResults.searched_contacts?.length > 0" class="mt-2 small text-muted">
              Searched {{ conflictResults.searched_contacts.length }} contact(s)
            </div>
            <!-- Approve Button -->
            <div *ngIf="conflictResults.conflicts?.length > 0 && !conflictResults.approved && canApproveConflicts" class="mt-3">
              <button type="button" class="btn btn-success btn-sm" [disabled]="approvingConflicts" (click)="approveConflicts()">
                <i class="fa fa-check mr-1"></i>
                {{ approvingConflicts ? 'Approving...' : 'Approve Conflicts & Proceed' }}
                <span *ngIf="approvingConflicts">&nbsp;<i class="fas fa-spinner fa-fw fa-pulse"></i></span>
              </button>
              <p class="small text-muted mt-1 mb-0">Approving confirms you have reviewed all conflicts and authorize proceeding with this matter.</p>
            </div>
            <div *ngIf="conflictResults.conflicts?.length > 0 && !conflictResults.approved && !canApproveConflicts" class="mt-3">
              <p class="small text-warning mb-0"><i class="fa fa-lock mr-1"></i>Only the lead attorney or an admin can approve conflicts.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
